module.exports = __webpack_public_path__ + "img/pizzaStocks.4fda8745.png";